import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    report: {},
    processes: [],
    process: {
      id: 0, // 0 or 1
      status: 1, // 1, 2, 3, 4, 5
      summons: 1, //0 or null
      record: 1,  // 0 or null1
      penalty: 3,  // 1 or null
      penaltyRecord: 1,  // 0 or null
      resource: 1,  // 0 or null
      resourceResponse: 1,// 0 or null
    },
    errorMsj: '',
  },
  getters: {

  },
  mutations: {
    setReport: (state, report) => {
      state.report = report;
    },
  },
  actions: {
    actCoordinatorsByBP: async ({
      commit
    }, id) => {
      let response = await ApiPermisos.getCoordinatorsByBP(id);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      return response.data;
    },
    actEmployeesByCoordinator: async ({
      commit
    }, id) => {
      let response = await ApiPermisos.getEmployeesByCoordinator(id);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      return response.data;
    },
    /*actGetReport: async ({
      commit
    }, id) => {
      let response = await ApiPermisos.getReport(id);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        return response;
      }
    },*/
    actGetReport: async ({
      commit,
    }, id) => {
      await ApiPermisos.getReport(id).then((response) => {
        commit('setReport', response.data);
      })
    },
    actSaveReport: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.saveReport(data);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        return response;
      }
    },
    actSaveReportEvidence: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.saveReportEvidence(data);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        commit('setReport', response.data);
        return response;
      }
    },
    actSaveReportEmployees: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.saveReportEmployees(data);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        return response;
      }
    },
    actUpdateProcessEmployee: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.updateProcessEmployee(data);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        return response;
      }
    },
    actSaveRequestEvidence: async ({
      commit
    }, data) => {
      let response = await ApiPermisos.saveRequestEvidence(data);
      if (response.error) {
        commit('errorMsj', response);
        return response;
      }
      else {
        commit('setReport', response.data);
        return response;
      }
    },
  },
}